module.exports = __webpack_public_path__ + "img/arrow-right-red.9e23afd8.svg";